
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/panels/promotionalPanels/optionalSectionsMigrationPanel/optionalSectionsMigrationPanel.scss.css.virtualfile';
        module.exports = {"listContainer":"_listContainer_1i9cf_7","check":"_check_1i9cf_11","loading":"_loading_1i9cf_14"};